import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { PageHero } from '../components/PageHero';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { GRADING_DETAIL } from '../lib/pageContent';
import { QUALITY_PAGE } from '../constants/testIds';

const META_DESCRIPTION =
  'How BulkUsedTires.com grades used tires: Grade A Premium, Grade B Standard and Grade C Commercial/Export, with tread depth and inspection criteria for each tier.';

export default function QualityGradesPage() {
  useDocumentMeta('Tire Grading Standards — A, B & C Grades Explained | BulkUsedTires.com', META_DESCRIPTION);

  return (
    <div className="min-h-screen bg-brand-bg">
      <Navbar />
      <PageHero
        eyebrow="Quality Grades"
        title="Tire Quality & Tread Depth Grading"
        description="Strict multi-point inspection and tread-depth measurement on every single tire before it ships worldwide."
      />
      <section data-testid={QUALITY_PAGE.section} className="py-16 sm:py-20">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 space-y-6">
          {GRADING_DETAIL.map((grade) => (
            <div key={grade.grade} className="rounded-2xl border border-brand-border bg-brand-surface p-7 sm:p-9">
              <h2 className="font-display font-bold uppercase text-brand-text text-2xl sm:text-3xl">{grade.grade}</h2>
              <p className="font-mono text-brand-orange text-lg sm:text-xl mt-2">
                {grade.tread} <span className="text-brand-muted text-sm">&middot; {grade.pct}</span>
              </p>
              <p className="mt-3 text-brand-muted text-sm sm:text-base leading-relaxed">{grade.desc}</p>
            </div>
          ))}

          <div className="rounded-2xl border border-brand-border bg-brand-surface2 p-7 sm:p-9 text-center">
            <p className="font-display font-bold uppercase text-brand-text text-xl sm:text-2xl">Not sure which grade fits your market?</p>
            <p className="mt-2 text-brand-muted text-sm sm:text-base">Tell us your target resale market and we will recommend a grade mix.</p>
            <a
              href="/#order-form"
              className="mt-5 inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3 transition-colors"
            >
              Request a Quote
            </a>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
